export default "__VITE_ASSET__DgVEQxGI__"